import React, {useCallback} from 'react';
import {Button} from "presentation/common";
import {useHistory} from "react-router-dom";
import AppRouters from "application/globals/app-routers";
import {Site} from "./site";
import {useAsync} from "react-use";
import {service} from "infrastructure";
import finger from './finger.svg';

import styles from './sites.module.scss';

export const Sites = () => {
  const history = useHistory();
  const newRequest = useCallback(
    () => {
      history.push(AppRouters.newReport)
    },
    [history],
  );

  const {error, loading, value} = useAsync(async () => {
    return await service.getSitesMapInfo();
  }, []);

  const urls = value?.data?.data?.url_apps;

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h1>No lo pienses más, solicita tu inscripción.</h1>
        <h1>Te mantendremos informado en cada paso del proceso.</h1>
        <Button label="Solicitar Inscripción" className={styles.btn} onClick={newRequest}/>
      </div>
      <h1 className={styles.sitesTitle}>Visita nuestras aplicaciones</h1>
      <div className={styles.sitesContainer}>
        {
          loading
            ? <span/>
            : <>
              <Site
                className={styles.idarContainer}
                href={urls?.idar}
                title="Reporte Automotriz"
                subTitle="Asegura tu inversión verificando la información del vehículo."
                message={
                  <p>
                    <strong>ID AUTO REPORTES</strong>,
                    conoce el historial completo de tu vehículo en cuestión de minutos. Verifica siempre antes de comprar.
                  </p>
                }/>
              <Site
                className={styles.walletContainer}
                href={urls?.idaw}
                title="!Ahora puedes!"
                subTitle="Portar tu documentación vehicular y acceder con un solo click."
                message={
                  <p>
                    <strong>ID AUTO WALLET</strong>,
                    visualiza y gestiona la documentación de tu vehículo de forma fácil y sencilla.
                  </p>
                }>
                <img src={finger} alt="finger" className={styles.finger}/>
              </Site>
            </>
        }
      </div>
    </div>
  );
};

Sites.propTypes = {}

Sites.defaultProps = {}

export default React.memo(Sites);
